import { render, staticRenderFns } from "./contrastDetails.vue?vue&type=template&id=dcfafb4e"
import script from "./contrastDetails.vue?vue&type=script&lang=js"
export * from "./contrastDetails.vue?vue&type=script&lang=js"
import style0 from "./contrastDetails.vue?vue&type=style&index=0&id=dcfafb4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports